import classNames from "classnames";
import Styles from "./Service.module.scss"
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";
import Footer from "../../Component/Footer/Footer";

const Happiness = () => {
    return (
        <div>
            <Navbar />
            <div style={{ padding: "8vh" }} className={classNames("container")}>

                <SubTitle text={`幸福二之一`} />
                <div className={classNames(Styles.service__item)}>

                    <h5 className={classNames(Styles.service__item__title)}>偏鄉身障或獨老二天一夜居家服務體驗</h5>
                    <h6 className={classNames(Styles.service__item__subtitle)}>(new，可直接報名體驗)</h6>
                    <p className={classNames(Styles.service__item__param)}>
                        體驗偏鄉老人的困境，為老人帶來幸福的二天一夜居家服務體驗活動。歡迎大家來為為花蓮長者帶來溫暖，關心老人，服務學習，體驗老化後的生活。
                    </p>
                    <h6 className={classNames(Styles.service__item__subtitle)}>活動內容</h6>
                    <p className={classNames(Styles.service__item__param)}>

                        提供二日中午用餐，花蓮當地服務時的交通接送、民宿安排，一人3999元。<br />
                    </p>
                    <div className={classNames(Styles.service__item__list)}>
                        <ul>
                            <li>
                                至花蓮報到
                            </li>
                            <li>至個案家中居家服務體驗</li>
                            <li>陪老人一起用餐、聊天</li>
                            <li>長照巴士一起走</li>
                            <li>能量大擁抱(山海負離子一起有)</li>
                            <li>心的回饋</li>
                            <li>賦歸</li>
                        </ul>
                    </div>
                    <p className={classNames(Styles.service__item__param)}>
                        <i>*活動會讓你有心靈體驗和大自然的體驗，讓能量滿滿。追求不一樣的服務體驗，感受深刻的幸福滋味，一起帶著愉悅的心來，帶著感恩的心回家。</i>
                    </p>

                </div>
            </div>
            <div>
                <Footer />
            </div>
        </div>
    )
}

export default Happiness;